module.exports = __webpack_public_path__ + "static/img/Surgery_Icon.1a63a63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/Surgery_Icon.jpg
// module id = pS41
// module chunks = 0